import { Box, Checkbox, FormControl, InputAdornment, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import LeftArrow from '../../../../../asset/svg/leftArrow.svg';
import SelectCheckListIcon from '../../../../../asset/svg/SelectCheckListIcon.svg';
import SearchIcon from '@mui/icons-material/Search';
import { useLocation, useNavigate } from 'react-router';
import '../../../../../scss/pages/Attendance/Component/Checklist/SelectChecklist/SelectChecklist.scss'
import { CHECKLIST_ADD_SCHEDULE_PATH, CHECKLIST_SELECT_STORE_PATH } from '../../../../../utils/Constants';
import { useDispatch, useSelector } from 'react-redux';
import { IS_CHECKED_DATA } from '../../../../../sagas/type';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
function SelectChecklist() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { selectStore } = location?.state;
    const { getChecklist } = useSelector(mapStateToProps);
    const [searchName, setSearchName] = useState('');
    const [checkBoxID, setCheckBoxID] = useState();
    const [isValid, setIsValid] = useState(false);

    const handleSearch = (event) => {
        const { value } = event.target
        setSearchName(value)
    }

    const handleBack = () => {
        navigate(CHECKLIST_SELECT_STORE_PATH, { state: { selectStore: selectStore } })
    }
    const handleDone = () => {
        navigate(CHECKLIST_ADD_SCHEDULE_PATH, { state: { selectStore: selectStore } })
    }

    const handleCheckBoxChange = (selectData) => {
        setCheckBoxID(selectData?.id)
        dispatch({
            type: IS_CHECKED_DATA,
            payload: selectData?.id
        })
    };

    useEffect(() => {
        if (getChecklist && getChecklist.length > 0) {
            const checkedChecklistData = getChecklist?.filter((item) => item?.checked == true);
            const isCheckItems = checkedChecklistData?.length > 0;
            setIsValid(isCheckItems)
        }
    }, [getChecklist])

    return (
        <div className='SelectChecklist-Container'>
            <div className='SelectChecklist-Container_header'>
                <div className='SelectChecklist-Container_header_head-height'>
                    <img className='SelectChecklist-Container_header_head-height_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp;
                    <span className='SelectChecklist-Container_header_head-height_content'>Select Checklist</span>
                </div>
                <div className='SelectChecklist-Container_buttonContainer'>
                    <button type='submit' disabled={!isValid} className='SelectChecklist-Container_buttonContainer_active-button' onClick={handleDone}>Done</button>
                </div>
            </div>
            <div className='SelectChecklist-Container_searchcontainer'>
                <FormControl sx={{ width: '100%', backgroundColor: 'rgba(255,255,255,0.18)', borderRadius: '12px', padding: 1 }}>
                    <TextField autoComplete="off" size="small" type='search' variant="outlined" placeholder='Search' onChange={handleSearch} value={searchName}
                        InputProps={{ startAdornment: (<InputAdornment position='start'>{searchName.length == 0 && <SearchIcon sx={{ color: 'rgba(255, 255, 255, 0.30)' }} />}</InputAdornment>), }} />
                </FormControl>
            </div>
            {getChecklist?.length > 0 ? getChecklist?.filter((item) => item?.scheduleType == "PLANNER" && item?.name?.toLowerCase().includes(searchName?.toLowerCase()))?.map((selectData) => {
                return (
                    <div key={selectData?.id} className='SelectChecklist-Container_content'>
                        <label htmlFor={`checkbox-${selectData?.id}`} className="SelectChecklist-Container_content_checkbox-label">
                            <Checkbox
                                id={`checkbox-${selectData?.id}`}
                                onChange={() => handleCheckBoxChange(selectData)}
                                checked={selectData?.checked}
                                color="primary"
                                sx={{
                                    color: "#fff",
                                    '&.Mui-checked': {
                                        color: "#8074FF",
                                        opacity: "1"
                                    },
                                    opacity: "0.3"
                                }}
                            />
                            <Typography sx={{ color: '#FFF', fontWeight: 600, fontSize: '14px', lineHeight: '17px', padding: '0px', fontFamily: "'Noto Sans', sans-serif" }}>
                                {selectData?.name}
                            </Typography>
                        </label>
                    </div>

                )
            }) :
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', marginTop: '10%' }}>
                    <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', width: '159px', height: '159px', borderRadius: '200px', background: 'rgb(222, 225, 255,0.06)', alignItems: 'center' }} >
                        <img style={{ heigth: '54px', width: '68px' }} src={SelectCheckListIcon} alt="" />
                    </div>
                    <div style={{ marginTop: '2rem', textAlign: 'center' }}>
                        <Typography fontStyle='normal' fontWeight='400' fontSize='16px' lineHeight='16px' textAlign='center' color='rgba(255,255,255,0.8)' >No Checklist</Typography>
                    </div>
                </div>
            }
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        getChecklist: state?.checklist?.getChecklist,
    }
}

export default SelectChecklist